'use client';

import { useCallback } from 'react';
import type { EmotionType } from '@/app/types';
import type { ActiveEmotionTag } from '../types';
import { EmotionSelectorPopover } from './EmotionSelectorPopover';

interface EmotionPopoverProps {
  emotionTag: ActiveEmotionTag;
  onChange: (emotion: EmotionType) => void;
  onClose: () => void;
}

export function EmotionPopover({ emotionTag, onChange, onClose }: EmotionPopoverProps) {
  const shouldCloseOnOutside = useCallback(
    (target: Node) => {
      // Don't close if clicking on the delete button next to the tag
      if ((target as HTMLElement).closest?.('[data-emotion-delete]')) return false;
      return !emotionTag.element.contains(target);
    },
    [emotionTag.element],
  );

  return (
    <EmotionSelectorPopover
      anchorRect={emotionTag.element.getBoundingClientRect()}
      selectedEmotionId={emotionTag.emotionId}
      selectedEmotionStyles={{
        backgroundColor: emotionTag.tagBackgroundColor,
        textColor: emotionTag.tagTextColor,
      }}
      onSelect={onChange}
      onClose={onClose}
      shouldCloseOnOutside={shouldCloseOnOutside}
    />
  );
}
